import React, { useRef, useState } from 'react';
// import { Button } from '@mui/material';
//import FileUploadIcon from '@mui/icons-material/FileUpload';
import CisModal from './CisModal';
import { readFile } from './pdfUtils';
import toast from 'react-hot-toast';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import CustomButton from '../../components/ui/Button/Button';
import { readRQ } from './fileTempates';
import { checkCisExistence } from '../../helper/helper';

const ManualCisBlock = ({eventinfoforCis}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [rqCISFormresult, setRqCISFormresult] = useState(null);
  const [loading, setLoading] =useState(false)
  const rqRefCISForm = useRef(null);

  const openModal = () => {
    if(loading) return
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  async function readRQCISForm(event) {
    const file = event.target.files[0];
    // Validating File type

    if (!file) {
      setRqCISFormresult('');
      return;
    }
    const { result } = await readFile(event);

    // Validate content for RQ file
    if (!result.startsWith('Sale Invoice :') || !result.includes('Thanks for your Business!')) {
      toast.error('The uploaded file does not appear to be a valid RQ file.');
      setRqCISFormresult(null);
      return;
    }
    let values = readRQ(result);
    setLoading(true)
    checkCisExistence(values?.saleInvoice)
      .then(({ exists, msg }) => {
        if (exists) {
          toast.error(msg || 'CIS data already exists for this Sale Invoice.');
        setRqCISFormresult(null);
        } else {
          if (values) {
            setRqCISFormresult(values);
          }
        }
      })
      .catch((error) => {
        toast.error(error || 'Error checking CIS existence.');
        setRqCISFormresult(null);
      }).finally(()=>setLoading(false)
  );
    // setRqCISFormresult(result);
  }

  return (
    <div className="cis">
      <div className="top">
        {/* <p>If you're having trouble uploading files automatically. Just enter the customer details manually and submit it — we'll take care of the rest.
</p>*/}
        <div className="block">
          
          <div className="top-block">
            <h4 className="">Manual Submission</h4> 
            {/*<h4>RQ4</h4>*/}

          </div>

          <div className="bottom-block">
         {/*   "Welcome! This form is here to help if you're having trouble uploading files automatically. Just enter the customer details manually and submit it — we'll take care of the rest."

            <label htmlFor="rq4" className="custom-file-label">Choose RQ4 Invoice</label>
            */}
            <input
              onChange={readRQCISForm}
              ref={rqRefCISForm}
              accept=".pdf"
              multiple={false}
              type="file"
              id="rq4"
              name="rq4"
              variant="outlined" 
            />
          </div>
          <CisModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            rqCISFormresult={rqCISFormresult}
            eventinfoforCis={eventinfoforCis}
          />
          <CustomButton
            // variant="contained"
            // color="success"
            buttonType="success"
            btnLabel='CIS FORM'
            onClick={openModal}
            disabled={!rqCISFormresult}
            customIcon={<FileOpenIcon />}
            loading={loading}
            type="submit"
          />
          
        </div>
      </div>
    </div>
  );
};

export default ManualCisBlock;
